<template>
  <div class="col-md-12">
    <a href="#" class="back-button mb-4 d-inline-block" @click="$emit('back')">{{ $t('Späť na byty') }}</a>
    <div class="d-flex align-items-center">
      <h3 class="flat-title" v-if="isOneAndHalfRoom"> {{ $t('Jeden a pol izbový') }} <span v-if="flatInfo.flat_type === '19'">{{ $t('apartmán') }}</span> <span v-else>{{ $t('byt') }}</span> {{flatInfo.flat_penta_internal_id}}</h3>
      <h3 class="flat-title" v-else-if="flatTitle"> {{ $t(flatTitle) }} {{flatInfo.flat_penta_internal_id}}</h3>
      <h3 class="flat-title" v-else-if="flatInfo.flat_penta_internal_id">{{flatInfo.flat_penta_internal_id}}</h3>
      <a class="ml-5 btn btn-primary rounded-0 add-to-compare" role="presentation" v-if="isInCompare" @click="$emit('remove-from-compare')">{{ $t('Odobrať z porovnania') }}</a>
      <a id="tooltip-target-1" class="ml-5 btn btn-secondary rounded-0 add-to-compare" role="presentation" v-else-if="compareCount >= 4">{{$t('Pridať do porovnania')}}</a>
      <a class="ml-5 btn btn-outline-primary rounded-0 add-to-compare" href="#" role="presentation" @click="$emit('add-to-compare')" v-else>+ {{$t('Pridať do porovnania')}}</a>
      <b-tooltip target="tooltip-target-1" triggers="hover">
        {{ $t('Nie je možné pridať do porovnávača. Max. počet bytov v porovnávači: 4') }}
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import { roomsTitle } from '@/utils/flats.util'

export default {
  name: "FlatHeader",
  props: {
    flatInfo: {
      type: Object,
      required: true
    },
    isInCompare: {
      type: Boolean,
      default: false
    },
    compareCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // Jeden a pol izbový byt má vlastný nadpis, zvyšok (1 až 9 izieb) rieši flats.util
    isOneAndHalfRoom() {
      return this.flatInfo.flat_number_of_rooms === '1,5' || this.flatInfo.flat_disposition === '1,5'
    },
    flatTitle() {
      return roomsTitle(this.flatInfo)
    }
  }
}
</script>

<style lang="sass" scoped>
$md: 768px

.flat-title
  font-size: 40px
  line-height: 45px
  font-weight: normal
  margin-bottom: 0

  @media (max-width: $md)
    font-size: 28px

.btn-outline-primary
  color: #7CB6D9
  border: 1px solid #7CB6D9
  padding-top: 10px
  padding-bottom: 10px

.back-button
  color: #fff
  font-weight: 500
  padding-left: 30px
  position: relative

  &:before
    content: ""
    width: 9px
    height: 17px
    background: url('../../assets/icons/arr-left.svg') no-repeat
    background-size: contain
    position: absolute
    left: 0
    top: 5px
</style>
